import axios from "axios";

const BASE_URL = "%REACT_APP_MBOOKING_API_URL%";

const axiosInstance = axios.create({
  baseURL: BASE_URL,
  headers: {
    "Content-Type": "application/json",
    "x-api-key": "%REACT_APP_MBOOKING_API_KEY%",
  },
});

export default axiosInstance;
